import React, { useState } from "react";
import Icon from "../ui/Icon";
import AgendaModal from "../modals/AgendaModal";

export default function TableSwitch({
  tables,
  currentTableId,
  sessionId, // kept for compatibility (not used)
  onSwitchTable,
  switching,
}) {
  const [panelShow, setPanelShow] = useState(false);
  const [selectedAgenda, setSelectedAgenda] = useState(null);

  return (
    <>
      {!panelShow && (
        <div className="gm-chat-shell">
          <div className="gm-chat-panel">
            <div className="gm-chat-header">
              <div className="gm-chat-headerLeft">
                <div className="gm-chat-headerIcon">
                  <Icon name="grid" />
                </div>
                <div>
                  <div className="gm-chat-title">Session Tables</div>
                  <div className="gm-chat-subtitle">
                    {tables?.length || 0} active rooms
                  </div>
                </div>
              </div>

              <button
                onClick={() => setPanelShow(true)}
                className="jt-mobileDrawerClose"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="gm-session-body">
              {!tables || tables.length === 0 ? (
                <div className="gm-session-empty">
                  <div className="gm-session-emptyIcon">🌿</div>
                  <div>No session tables available</div>
                </div>
              ) : (
                tables.map((t) => {
                  const isCurrent =
                    String(t._id || t.id) === String(currentTableId);

                  const isFull = Boolean(t.isFull);

                  const isUserInThisTable =
                    Boolean(t.isUserInTable) || isCurrent;

                  const isQueued = Boolean(t.isUserQueued);
                  const actionLabel = isQueued
                    ? t.queuePosition
                      ? `Waiting (${t.queuePosition})`
                      : "Waiting"
                    : isFull
                      ? "Join queue"
                      : "Join";

                  return (
                    <div
                      key={t._id || t.id}
                      className={`gm-session-card ${isCurrent ? "active" : ""}`}
                    >
                      <div className="gm-session-left">
                        <div className="gm-session-info">
                          <div className="gm-session-name">
                            {t.tableName || "Table"}
                          </div>

                          <div className="gm-session-meta">
                            <span>
                              {t.currentOccupancy || 0}/{t.capacity || 8} joined
                            </span>

                            <span className="gm-session-dot"></span>

                            <span>
                              {isCurrent
                                ? "Current session"
                                : isFull
                                  ? "Room full"
                                  : "Open to join"}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="gm-session-actions">
                        {isUserInThisTable ? (
                          <div className="gm-session-joined">
                            {isCurrent ? "You are here" : "Already joined"}
                          </div>
                        ) : (
                          <>
                            <button
                              className={`gm-session-switchBtn ${
                                isQueued ? "disabled" : ""
                              }`}
                              onClick={() => onSwitchTable(t)}
                              disabled={switching || isQueued}
                              type="button"
                            >
                              {switching ? "Switching..." : actionLabel}
                            </button>
                            {t.agenda && !isUserInThisTable && (
                              <button
                                onClick={() => setSelectedAgenda(t)}
                                className="gm-view-agenda-btn"
                                type="button"
                              >
                                📋 View Agenda
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}

      <AgendaModal
        open={!!selectedAgenda}
        onClose={() => setSelectedAgenda(null)}
        title={`${selectedAgenda?.tableName || "Table"} — Agenda`}
        agendaHtml={selectedAgenda?.agenda || ""}
      />
    </>
  );
}
